<button [ngClass]="{'modal': modalFooter, 'blue-button': true, 'grey-button': buttonType == 'grey'}"
        *ngIf="href == ''"
        [disabled]="disabled"
        role="button" title="{{label | translate}}" translate
        type="submit">
  <i *ngIf="activeArrow && iconClass == ''" class="pi pi-arrow-right blue-button-arrow"></i>
  <span translate><i *ngIf="iconClass !== ''" class="pi pi-{{iconClass}}"></i>{{label}}</span>
</button>

<a [ngClass]="{'modal': modalFooter, 'blue-button': true, 'grey-button': buttonType == 'grey'}"
        *ngIf="href != ''"
        href="{{href}}"
        role="button" title="{{label | translate}}" translate
        type="submit">
  <i *ngIf="activeArrow && iconClass == ''" class="pi pi-arrow-right blue-button-arrow"></i>
  <span translate><i *ngIf="iconClass !== ''" class="pi pi-{{iconClass}}"></i>{{label}}</span>
</a>
